export const SITE_NAME = "Gazmatek";
export const SITE_URL = "https://booking.Gazmatek.com";

/**
 * Set to true to enable /:lang/* routing (e.g. /en/, /fr/).
 * Set to false for a single-language app — standard routing is used instead.
 */
export const I18N_ROUTING = true;
